import type { Theme } from "@mui/material/styles";
import type { AppBreadcrumbsShellStyles, BreadcrumbsToneOwnerState, MdTheme } from "../types";

function toneColor(theme: Theme, ownerState: BreadcrumbsToneOwnerState = {}) {
  const { light = false, darkMode = false } = ownerState;
  if (light || darkMode) {
    return "white !important";
  }
  return `${theme.palette.text.primary} !important`;
}

export function buildBreadcrumbsStyles(theme: Theme): AppBreadcrumbsShellStyles {
  const { typography } = theme as MdTheme;
  const { size } = typography;

  return {
    container: {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      minHeight: "100%",
      // Keep clear of the chrome edges while staying vertically centered.
      py: { xs: 1, sm: 1.25 },
      px: { xs: 0.5, sm: 0.75 },
      mr: { xs: 0, xl: 4 },
      boxSizing: "border-box",
    },
    row: {
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
      minWidth: 0,
      maxWidth: "100%",
    },
    icon: (ownerState) => ({
      color: toneColor(theme, ownerState),
      fontSize: `${size["2xl"]} !important`,
      width: size["2xl"],
      height: size["2xl"],
      lineHeight: 1,
      flexShrink: 0,
    }),
    label: (ownerState) => ({
      color: toneColor(theme, ownerState),
      fontSize: "1.05rem",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: "-0.01em",
      textTransform: "capitalize",
    }),
    root: (ownerState) => {
      const { light = false, darkMode = false } = ownerState ?? {};
      const { white, text } = theme.palette;
      return {
        "& .MuiBreadcrumbs-separator": {
          color: light || darkMode ? white.main : text.primary,
        },
        "& a": {
          textDecoration: "none",
          color: "inherit",
          "&:hover, &:visited, &:focus": {
            textDecoration: "none",
            color: "inherit",
          },
        },
      };
    },
    link: {
      textDecoration: "none",
      color: "inherit",
    },
    crumbText: (ownerState) => ({
      lineHeight: 1,
      color: toneColor(theme, ownerState),
    }),
    currentText: (ownerState) => ({
      lineHeight: 1.2,
      color: toneColor(theme, ownerState),
    }),
    pageTitle: (ownerState) => ({
      color: toneColor(theme, ownerState),
    }),
  };
}
